function Popup(){

	this.popup 					= document.createElement('div');
	this.popup_body 			= document.createElement('div');
	this.popup_close 			= document.createElement('button');
	this.popup_close_overlay 	= document.createElement('div');
	this.content_holder;

	this.start = (function(){
		for(var key in this){
			if(typeof this[key] === "function" && key.indexOf('_') !== 0){
				this[key]();
			}
		}
	}.bind(this))();

}

( function ( $ ){

	var Pp = Popup.prototype;

	Pp._show_popup = function( btn ){

		var _self = this,
			id = btn.getAttribute('data-popup'),
			callback = btn.getAttribute('data-callback');

		_self._return_html_to_original_location();

		var content_holder = document.getElementById( id );

		this.content_holder = content_holder;

		if ( ! content_holder ){
			console.log('Related content does not exist.');
			return;
		}

		while ( content_holder.firstChild ){
			this.popup_body.appendChild ( content_holder.firstChild );
		}

		$( this.popup ).fadeIn( 200 );

		[ this.popup_close_overlay , this.popup_close ].forEach(function( btn ){
			btn.addEventListener( 'click', function(){
				_self._close_popup();
			});
		});

		document.body.classList.add( 'is-popup-active' );
		document.body.setAttribute('data-popupactive' , id );

		this.popup.id = 'popup-id-' + id;

		if( window[callback] ) window[callback](btn);
		
		document.addEventListener('keyup', function(e){
			if( e.which == 27 ){
				_self._close_popup();
			}
		});

	};

	Pp._close_popup = function(){

		var _self = this;
		
		$( this.popup ).fadeOut( 200 , function(){

			_self._return_html_to_original_location();
			document.body.classList.remove( 'is-popup-active' );
			document.body.removeAttribute( 'data-popupactive' );

		});
		
	};

	Pp._return_html_to_original_location = function(){
		
		if ( ! this.content_holder ) return;
		
		while ( this.popup_body.firstChild ){

			this.content_holder.appendChild ( this.popup_body.firstChild );

		}

	};

	Pp.popup_structure = function(){
		
		var _self = this;

		this.popup.className = 'l-spread l-center js-popup';
		this.popup.style.display = 'none';
		this.popup.setAttribute( 'aria-hidden', 'true' );
		this.popup.setAttribute( 'role', 'dialog' );
		
		this.popup_body.className = 'popup-body';

		this.popup_close.className = 't-hover js-popup-btn-close';
		this.popup_close.setAttribute( 'aria-label', lib.translation('סגור','close'));
		this.popup_close.setAttribute( 'aria-modal', true);

		this.popup_close_overlay.className = 'l-spread';

		var popup_wrap = document.createElement('div');
		popup_wrap.className = 'l-layer-up';
		popup_wrap.appendChild(this.popup_body);
		popup_wrap.appendChild(this.popup_close);

		this.popup.appendChild( popup_wrap );
		this.popup.appendChild( this.popup_close_overlay );
		
		document.body.appendChild( this.popup );

	};

	Pp.init = function(){

		var btns = document.querySelectorAll('[data-popup]');

		if ( ! btns.length ) return;

		var _self = this;

		[].forEach.call( btns , function( btn ){

			btn.addEventListener( 'click' , function(e){
				
				e.preventDefault();

				_self._show_popup( this );

			});
		});
	};


}(window.jQuery) );

window.popup = new Popup();


// WEBPACK FOOTER //
// ./assets/js/general/a-popup.js